// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1osg_","right":"styles_right__2bpip"};